import { Component, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TimesheetUtilityService } from '@app/main/time-sheet-new/services/timesheet-utility.service';
import * as _ from 'lodash';
import { DateTime } from 'luxon';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { ActivityServiceProxy, AllDashboardServiceProxy, GetApplicationsDto } from '../../../../../shared/service-proxies/service-proxies';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    selector: 'app-dashboard-productiveapps',
    templateUrl: './dashboard-productiveapps.component.html',
    styleUrls: ['./dashboard-productiveapps.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardProductiveappsComponent extends AppComponentBase implements OnInit, OnDestroy {
    productiveAppsDetails: GetApplicationsDto[];
    showProductiveDetails: any;
    isLoaded = false;
    isEmpty = true;
    istrueValue: boolean;
    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy, private _activitesServiceProxy: ActivityServiceProxy, public _tus: TimesheetUtilityService, private router: Router, injector: Injector) { super(injector); }
    ngOnInit(): void {
        this.getAllProductiveApps();
    }
    getAllProductiveApps() {
        this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
        let date = new Date();
        this._AllDashboardServiceProxy.getUserWiseProductiveApplication('', [], [], [], this.istrueValue, undefined, false, date.getTimezoneOffset()).subscribe(result => {
            this.productiveAppsDetails = [];
            result = _.orderBy(result, ['applicationSpendTime'], ['desc']);
            result.forEach(x => {
                if (x.applicationSpendTime) {
                    this.productiveAppsDetails.push(x);
                    this.isEmpty = false;
                }
            });
            this.isLoaded = true;
            this.markForCheck();
        });
    }
    timerToHrsMinSec(timer: string) {
        let hrsStr = (timer.split(':')[0]);
        let minsStr = timer.split(':')[1];
        let secsStr = timer.split(':')[2];
        let hrs = Math.floor(parseFloat(hrsStr));
        let mins = Math.floor(parseFloat(minsStr));
        let secs = Math.floor(parseFloat(secsStr));
        if (mins == 0 && hrs == 0) {
            return `${secs} s`;
        }
        else {
            return timer.slice(0, 5) + ' h';
        }
    }
    viewall() {
        this.router.navigate([AppRoutes.activitiesTimeAndAttendance]);
    }
    ngOnDestroy() {
        if (this.showProductiveDetails) {
            clearInterval(this.showProductiveDetails);
        }
    }
    ShowDetails = false;
    LoadingStarted = false;
    HistoryForApp = "";
    HistoryDetails = [];
    userId = abp.session.userId;
    tenantId = abp.session.tenantId;
    GetData(appName: string) {
        this.HistoryForApp = appName;
        this.ShowDetails = false;
        document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
        this.LoadingStarted = true;
        this._activitesServiceProxy.getActiveWindowsHistoryForApp(appName, DateTime.fromJSDate(this.setZeroTimeForLocalDate(new Date())), this.userId, this.tenantId).subscribe(res => {
            this.HistoryDetails = res;
            this.LoadingStarted = false;
            this.HistoryForApp = "";
            if (this.HistoryDetails.length > 0) {
                this.ShowDetails = true;
                let element = document.getElementsByClassName('popTemplateClass');
                for (let i = 0; i < element.length; i++) {
                    element[i].className = element[i].className.replace(/\bdisplay-none\b/, "");
                }
            }
            else {
                this.ShowDetails = false;
                if (document.getElementsByClassName('popTemplateClass')?.length)
                    document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
            }
            this.markForCheck();
        });
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    removeData() {
        this.HistoryForApp = "";
        this.LoadingStarted = false;
        this.ShowDetails = false;
        this.HistoryDetails = [];
    }
}
